(() => {
  const pages = document.querySelectorAll('[data-hj-product-page]');

  const formatMoney = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD'
    }).format(amount);
  };

  pages.forEach((page) => {
    const dataEl = page.querySelector('[data-hj-product-json]');
    let data = { variants: [], currency: 'USD' };
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (error) {
        data = { variants: [], currency: 'USD' };
      }
    }

    const mediaItems = Array.from(page.querySelectorAll('[data-hj-media]'));
    const thumbButtons = Array.from(page.querySelectorAll('[data-hj-thumb]'));
    const counter = page.querySelector('[data-hj-counter]');
    const variantInputs = Array.from(page.querySelectorAll('[data-hj-variant-input]'));
    const priceEl = page.querySelector('[data-hj-price]');
    const compareEl = page.querySelector('[data-hj-compare]');
    const saleEl = page.querySelector('[data-hj-sale]');
    const skuEl = page.querySelector('[data-hj-sku]');
    const skuWrap = page.querySelector('[data-hj-sku-wrap]');
    const stockEl = page.querySelector('[data-hj-stock]');
    const stockWrap = page.querySelector('[data-hj-stock-wrap]');
    const styleLabel = page.querySelector('[data-hj-style-label]');
    const addButton = page.querySelector('[data-hj-add-button]');
    const addLabel = page.querySelector('[data-hj-add-label]');
    const stickyPrice = page.querySelector('[data-hj-sticky-price]');
    const stickyAddButton = page.querySelector('[data-hj-sticky-add]');
    const stickyAddLabel = page.querySelector('[data-hj-sticky-label]');
    const paymentWrap = page.querySelector('[data-hj-payment-wrap]');
    const stickyBar = page.querySelector('[data-hj-mobile-sticky]');
    const stickyTrigger = paymentWrap || page.querySelector('.hj-product-cart-row');
    const getPaymentButtons = () => Array.from(page.querySelectorAll('.shopify-payment-button button, .shopify-payment-button__button'));

    const setMedia = (mediaId) => {
      if (!mediaId) return;
      let activeIndex = 0;
      mediaItems.forEach((item, index) => {
        const active = item.dataset.mediaId === String(mediaId);
        item.classList.toggle('is-active', active);
        if (active) activeIndex = index;
      });
      thumbButtons.forEach((button) => {
        const active = button.dataset.mediaId === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = `${activeIndex + 1} / ${Math.max(mediaItems.length, 1)}`;
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => setMedia(button.dataset.mediaId));
    });

    const optionInputs = Array.from(page.querySelectorAll('[data-hj-option]'));
    const getSelectedOptions = () => {
      const groups = {};
      optionInputs.forEach((input) => {
        if (input.checked) groups[input.name] = input.value;
      });
      return Object.values(groups);
    };

    const findVariant = () => {
      const selected = getSelectedOptions();
      if (!selected.length) {
        return data.variants?.find((variant) => String(variant.id) === String(data.selectedVariantId)) || data.variants?.[0];
      }
      return data.variants.find((variant) => {
        return selected.every((value, index) => variant.options[index] === value);
      });
    };

    const getVariantAvailabilityState = (variant) => {
      if (!variant) return 'sold_out';
      if (variant.availability_state) return variant.availability_state;
      if (variant.available === true || variant.available === 'true') return 'available';
      if (Number(variant.inventory_quantity || 0) > 0) return 'available';
      if (variant.inventory_policy === 'continue') return 'available';
      if (variant.inventory_management && variant.inventory_quantity == null) {
        return 'regional_unavailable';
      }
      return 'sold_out';
    };

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant) return;
      const availabilityState = getVariantAvailabilityState(variant);
      const isAvailable = availabilityState === 'available';
      const stockText = availabilityState === 'available'
        ? 'In stock'
        : availabilityState === 'regional_unavailable'
          ? 'Not available in your region'
          : 'Sold out';
      const actionText = availabilityState === 'available'
        ? data.addToCartLabel || 'Add to Cart'
        : availabilityState === 'regional_unavailable'
          ? 'Unavailable in your region'
          : 'Sold out';

      variantInputs.forEach((input) => { input.value = variant.id; });
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.currency);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, data.currency);
      if (compareEl) {
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !hasCompare;
        compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price, data.currency) : '';
        if (saleEl) saleEl.hidden = !hasCompare;
      }
      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        if (skuWrap) skuWrap.hidden = !variant.sku;
      }
      if (stockEl) stockEl.textContent = stockText;
      if (stockWrap) stockWrap.dataset.state = availabilityState;
      if (styleLabel) styleLabel.textContent = variant.public_title || variant.title || styleLabel.textContent;
      if (addLabel) addLabel.textContent = actionText;
      if (addButton) addButton.disabled = !isAvailable;
      if (stickyAddLabel) stickyAddLabel.textContent = actionText;
      if (stickyAddButton) stickyAddButton.disabled = !isAvailable;
      if (paymentWrap) {
        paymentWrap.classList.toggle('is-disabled', !isAvailable);
        paymentWrap.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      }
      getPaymentButtons().forEach((button) => {
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
      if (variant.featured_media && variant.featured_media.id) setMedia(variant.featured_media.id);
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const group = input.closest('[data-hj-option-group]');
        if (group) {
          group.querySelectorAll('.hj-product-option').forEach((label) => {
            label.classList.toggle('is-active', label.contains(input) && input.checked);
          });
        }
        updateVariant();
      });
    });

    updateVariant();

    const qtyInput = page.querySelector('[data-hj-qty-input]');
    const minus = page.querySelector('[data-hj-qty-minus]');
    const plus = page.querySelector('[data-hj-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, Number(qtyInput.value || 1) - 1);
      });
      plus.addEventListener('click', () => {
        qtyInput.value = Number(qtyInput.value || 1) + 1;
      });
    }

    stickyAddButton?.addEventListener('click', () => {
      if (!addButton || addButton.disabled) return;
      addButton.click();
    });

    if (stickyBar && stickyTrigger && stickyAddButton) {
      let stickyFrame = 0;
      const cartDrawer = document.querySelector('.hj-cart-drawer');

      const syncStickyVisibility = () => {
        stickyFrame = 0;
        const drawerOpen = cartDrawer?.classList.contains('is-open') || cartDrawer?.getAttribute('aria-hidden') === 'false';
        const shouldShow = window.matchMedia('(max-width: 989px)').matches
          && stickyTrigger.getBoundingClientRect().bottom <= 0
          && !drawerOpen;

        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        stickyAddButton.tabIndex = shouldShow ? 0 : -1;
      };

      const scheduleStickyVisibility = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(syncStickyVisibility);
      };

      window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });
      window.addEventListener('resize', scheduleStickyVisibility);
      if (cartDrawer && typeof MutationObserver !== 'undefined') {
        new MutationObserver(scheduleStickyVisibility).observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });
      }
      syncStickyVisibility();
    }
  });
})();
